/**
 * Shared layout values for the landing page, lifted verbatim out of the
 * design's `Landing.jsx` so every section stays on the same grid.
 *
 * Mobile is the primary layout (390px); desktop kicks in above 720px.
 */

/**
 * Centred page container: 1120px max on desktop, 390px on mobile.
 *
 * The side padding is set as two longhands rather than the `padding`
 * shorthand: every caller spreads this and then adds its own `paddingTop`,
 * and React warns on each rerender when a shorthand and a longhand for the
 * same property meet in one style object.
 */
export function wrap(desktop) {
  return {
    maxWidth: desktop ? 1120 : 390,
    margin: '0 auto',
    paddingLeft: desktop ? 32 : 20,
    paddingRight: desktop ? 32 : 20,
    boxSizing: 'border-box',
  }
}

/** Vertical rhythm between sections: 96px desktop, 56px mobile. */
export function sectionGap(desktop) {
  return desktop ? 96 : 56
}

/** Section heading scale. */
export function h2Style(desktop) {
  return { fontSize: desktop ? 36 : 28, margin: 0, letterSpacing: '-0.02em' }
}
